import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAG6fiNQp9bViZ1N8mkZg76vhsvaw0BJ1I",
  authDomain: "node-mcu-iot-635e6.firebaseapp.com",
  databaseURL: "https://node-mcu-iot-635e6-default-rtdb.firebaseio.com",
  projectId: "node-mcu-iot-635e6",
  storageBucket: "node-mcu-iot-635e6.appspot.com",
  messagingSenderId: "473103408422",
  appId: "1:473103408422:web:ea95163682cfbe8ea535e7"
};


const app = initializeApp(firebaseConfig);

export default app;


